module.exports = __webpack_public_path__ + "static/media/attitude2.7b60f31f.png";